import { useCallback, useEffect, useMemo, useRef, useState } from "react"
import { ErrorCard, LoadingCard, MainContainer, } from "../../components"
import { Button, Autocomplete, AutocompleteItem, Checkbox, Input, addToast, Select, SelectItem, Chip, Card, CardBody, Divider, Modal, NumberInput, Tab, Tabs, Textarea } from "@heroui/react"
import { dateCalendarClasses, DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import dayjs from "dayjs"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs"
import { apiRoute, ENUM_BILL_TYPE, ENUM_CURRENCY_SETTING_VAL, ENUM_ENTRY_TYPE, ENUM_INPUT_TYPE, ENUM_MOD_NAME, ENUM_MOD_PARAMETER, ENUM_TRADE_TYPE, ENUM_TRADEOF_CODE, ENUM_TRADEOF_TYPE, funValidateNoInput, getModMandatory, getModValue, getModVisiblity, linksUrl, URIEncrypt, } from "../../constants/enum"
import { isMobile } from "react-device-detect"
import { useFetchWithBody, usePost } from "../../api/reactQueryCustomHooks"
import { useDispatch, useSelector } from "react-redux"
import { faCancel, faClose, faFile, faFileEdit, faGem, faPenToSquare, faPlus, faSave, faSquareXmark, faTrashCan } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { toast } from "react-toastify"
import { useNavigate, useParams } from "react-router-dom"
import { calculateTotal, funCheckNumber, scrollInput, stickyBottomClass, stickyParentClass } from "../../Utility/utility"
import { Box, Drawer, } from "@mui/material"
import * as XLSX from 'xlsx';

import DynamicTable from "./DynamicTable"
import { resetDetailParams } from "../../state/roughAllotmentEntrySlice"

const CreateRoughAllotmentEntry = () => {
    const { compCode, isMultipleCompany, compState } = useSelector((state) => state.company)
    const { isNewEntry, detailParams } = useSelector((state) => state.roughAllotment)
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();
    const [entryLabel, setEntryLabel] = useState("Rough Allotment")
    const [selBillType, setSelBillType] = useState('O')
    const [selTradeOf, setSelTradeOf] = useState("")
    const [selLotAllotData, setSelLotAllotData] = useState({})
    const [naviCode, setnaviCode] = useState()
    const [rows, setRows] = useState([])
    const [deletedItemRows, setDeletedItemRows] = useState([])
    const [selectedRowId, setSelectedRowId] = useState("")
    const [selTabKey, setSelTabKey] = useState("orgAllotment");
    const [CurrencySetting, setCurrencySetting] = useState("")
    const [submitBtnId, setSubmitBtnId] = useState("")
    const dispatch = useDispatch()

    // /mutate: filterMasterData
    const { data: masterData = [], isLoading: isPendingData, } = useFetchWithBody({
        url: apiRoute.roughAllotmentEntry.entryMasterData,
        queryKey: "masterDataRough",
        inputData: {
            comp_code: compCode.join(",")
        }

    })

    const { isError: isErrorModSet, data: modSetting = [], } = useFetchWithBody({
        url: apiRoute.modSetting.getModSetting,
        queryKey: "fetchModSettingStockItem",
        inputData: {
            mod_name: ENUM_MOD_NAME.GeneralSettings
        }
    })
    useEffect(() => {

        setCurrencySetting(getModValue(ENUM_MOD_PARAMETER.GeneralSetting.CurrencyType, modSetting) ?? ENUM_CURRENCY_SETTING_VAL.RS)
    }, [modSetting])
    const [deleteRowsLotlAssort, setDeleteRowsLotAssort] = useState([])
    const [deleteRowsOriginalAssort, setDeleteRowsOriginalAssort] = useState([])
    const ENUM_RateOn = [
        { key: "R", value: "Rough" },
        { key: "D", value: "Demand Weight" },
        { key: "O", value: "Polish Weight" },
        { key: "P", value: "Polish Pcs" },
    ]

    const refInput = useRef(null)
    const onSuccessTasks = (data) => {
        dispatch(resetDetailParams());
        if (submitBtnId == 'btnSaveNew') {
            setFormData(emptyFormField)
            setRows([])
            window.location.reload();
        }
        else
            navigate(funGetMasterLink());
    }
    const { isError, isPending, mutate: funAddUpdate } = usePost({
        url: apiRoute.roughAllotmentEntry.add_update,
        queryKey: "funAddUpdateAllotment",
        onSuccessTasks
    })


    const { isError: isErrorDetail, data: detail = [], mutate: funGetDetail } = usePost({
        url: apiRoute.roughAllotmentEntry.fetchEntryDetail,
        queryKey: "fetchAlllotDetail",
    });

    const { isLoading, data: diamParamData = [], } = useFetchWithBody({
        url: apiRoute.roughAllotmentEntry.diamParamData,
        queryKey: "fetchDiamParamsetail",
    });


    //console.log(diamParamData)
    const { data: dupRoughNo = [], mutate: funChkRoughNo } = usePost({
        url: apiRoute.roughAllotmentEntry.checkRoughNo,
        queryKey: "checkRoughtNo",
        onSuccessTasks: (data) => {
            if (data && data.length > 0) {
                //if (data.length > 0) {
                setFormData({ ...formData, [formField.roughNo]: "" })
                if (!toast.isActive('toats_chkRoughno')) {
                    toast.error("Duplicate Rough No not Allow", {
                        "position": "top-center",
                        "className": "toast-error",
                        toastId: "toats_chkRoughno",


                    })
                }

                //}
            }

        }

    })

    useEffect(() => {
        if (isMultipleCompany)
            navigate(linksUrl.dashboard.tradingDashboard)

        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            const { comp_code, rough_code } = detailParams
            // console.log(detailParams)
            funGetDetail({
                data: {
                    compcode: comp_code,
                    rgh_code: rough_code
                }
            })
        }
    }, [])


    const formField = {
        roughNo: "roughNo",
        inwardDate: "inwardDate",
        article: "article",
        weight: "weight",
        rateRs: "rateRs",
        rateD: "rateD",
        valueRs: "valueRs",
        valueD: "valueD",
        convRate: "convRate",
        partyId: "partyId",
        remark: "remark"
    }

    const emptyFormField = Object.keys(formField).reduce((acc, key) => {
        if (key == formField.inwardDate)
            acc[key] = new Date()
        else if ([formField.roughNo, formField.remark, formField.article].includes(key))
            acc[key] = ""
        else acc[key] = 0
        return acc
    }, {})

    const [formData, setFormData] = useState({
        ...emptyFormField
    })

    
    const RowsField = {
        srNo: "srNo",
        detNo: "detNo",
        detailId: "detailId",
        assortCode: "assortCode",
        weight: "weight",
        rateRs: "rateRs",
        rateD: "rateD",
        valueRs: "valueRs",
        valueD: "valueD",
        lotNo: "lotNo",
        assortNo: "assortNo",
        clvDate: "clvDate",
        cleaver: "cleaver",
        weight: 'weight',
        finalDate: "finalDate",
        convRate: "convRate",
        rejectionType: "rejectionType",
        processType: "processType",
        lossWeight: "lossWeight",
        lossPer: "lossPer",
        partyId: "partyId",
        shapeCode: "shapeCode",
        colorCode: "colorCode",
        purityCode: "purityCode",
        sizeCode: "sizeCode",
        charni: "charni",
        roughCts: "roughCts",
        demandCts: "demandCts",
        polishCts: "polishCts",
        polishPcs: "polishPcs",
        rateOn: "rateOn",

    }
    //original Assort
    const [rowsOriginalAssort, setRowsOriginalAssort] = useState([
        { id: 1, [RowsField.detailId]: 0, [RowsField.assortCode]: "", [RowsField.weight]: 0, [RowsField.rateD]: 0, [RowsField.valueD]: 0, [RowsField.rateRs]: 0, [RowsField.valueRs]: 0 }])
    const columnsOrignalAssort = [
        {
            label: 'Assortment No', name: RowsField.assortCode, type: 'select', required: true,
            data: masterData && masterData.clvMaster ? masterData.clvMaster : [], keyfield: "Clv_Code", valuefield: "Clv_Desc"
        },
        { label: 'Weight', name: RowsField.weight, type: 'number', required: true, },
        { label: 'Rate $', name: RowsField.rateD, type: 'number' },
        { label: 'Value $', name: RowsField.valueD, type: 'number', readonly: true },
        { label: 'Rate Rs.', name: RowsField.rateRs, type: 'number' },
        { label: 'Value Rs.', name: RowsField.valueRs, type: 'number' },
    ]
    //console.log(rowsOriginalAssort, "assort")
    //Lot Assort
    const [rowsLotlAssort, setRowsLotAssort] = useState([
        {
            id: 1, [RowsField.detailId]: 0, [RowsField.lotNo]: "", [RowsField.assortCode]: "", [RowsField.clvDate]: null,
            [RowsField.cleaver]: "", [RowsField.weight]: 0, [RowsField.rateD]: 0,
            [RowsField.convRate]: 0, [RowsField.rateRs]: 0, [RowsField.finalDate]: null
        }])

    const columnsLotAssort = [
        { label: '', name: "detail", type: 'button' },
        { label: 'Lot No', name: RowsField.lotNo, type: "text", required: true },
        {
            label: 'Assort No', name: RowsField.assortCode, type: 'select', required: true,
            data: masterData && masterData.clvMaster ? masterData.clvMaster : [], keyfield: "Clv_Code", valuefield: "Clv_Desc"
        },
        { label: 'Clv.Date', name: RowsField.clvDate, type: 'date' },
        {
            label: 'Cleaver', name: RowsField.cleaver, type: 'select', required: true,
            data: masterData && masterData.empMaster ? masterData.empMaster : [], keyfield: "Party_Id", valuefield: "Party_Name"
        },
        { label: 'Weight', name: RowsField.weight, type: 'number', required: true, },
        { label: 'Rate $', name: RowsField.rateD, type: 'number' },
        { label: '$-Rs', name: RowsField.convRate, type: 'number' },
        { label: 'Rate Rs.', name: RowsField.rateRs, type: 'number' },
        { label: 'Final Date', name: RowsField.finalDate, type: 'date' },

    ]
    // Rejection Detail
    const [deleteRowsRejectionDetail, setDeleteRowsRejectionDetail] = useState([])
    const [rowsRejectionDetail, setRowsRejectionDetail] = useState([
        {
            id: 1, [RowsField.detailId]: 0, [RowsField.rejectionType]: "", [RowsField.weight]: 0, [RowsField.rateD]: 0, [RowsField.valueD]: 0,
            [RowsField.rateRs]: "", [RowsField.valueRs]: 0
        }])

    const columnsRejectionDetail = [
        {
            label: 'Rejection Type', name: RowsField.rejectionType, type: 'select', required: true,
            data: masterData && masterData.rejTypeMaster ? masterData.rejTypeMaster : [], keyfield: "Clv_Code", valuefield: "Clv_Desc"
        },
        { label: 'Weight', name: RowsField.weight, type: 'number', required: true, },
        { label: 'Rate $', name: RowsField.rateD, type: 'number' },
        { label: 'Value $', name: RowsField.valueD, type: 'number' },
        { label: 'Rate Rs.', name: RowsField.rateRs, type: 'number' },
        { label: 'Value Rs.', name: RowsField.valueRs, type: 'number' },
    ]

    // Process Detail
    const [deleteRowsProcessDetail, setDeleteRowsProcessDetail] = useState([])
    const [rowsProcessDetail, setRowsProcessDetail] = useState([
        {
            id: 1, [RowsField.detailId]: 0, [RowsField.processType]: "", [RowsField.weight]: 0, [RowsField.lossWeight]: 0, [RowsField.lossPer]: 0,
            [RowsField.rateRs]: "", [RowsField.valueRs]: 0, [RowsField.valueD]: 0
        }])

    const columnsProcessDetail = [
        {
            label: 'Process', name: RowsField.processType, type: 'select', required: true,
            data: masterData && masterData.procMaster ? masterData.procMaster : [], keyfield: "Process", valuefield: "Proc_Desc"
        },
        { label: 'Process Weight', name: RowsField.weight, type: 'number', required: true },
        { label: 'Weight Loss', name: RowsField.lossWeight, type: 'number' },
        { label: 'Loss %', name: RowsField.lossPer, type: 'number' },
        { label: 'Labour Rate Rs.', name: RowsField.rateRs, type: 'number', required: true },
        { label: 'Labour Amt. Rs.', name: RowsField.valueRs, type: 'number' },
        { label: 'Labour Amt. $', name: RowsField.valueD, type: 'number' },
    ]


    // Manufacturing Detail
    const [deleteRowsManufacturingDetail, setDeleteRowsManufacturingDetail] = useState([])
    const [rowsManufacturingDetail, setRowsManufacturingDetail] = useState([
        {
            id: 1, [RowsField.detailId]: 0, [RowsField.partyId]: "", [RowsField.shapeCode]: "", [RowsField.charni]: "",
            [RowsField.roughCts]: 0, [RowsField.demandCts]: 0, [RowsField.polishCts]: 0, [RowsField.polishPcs]: 0, [RowsField.rateOn]: '',
            [RowsField.rateRs]: "", [RowsField.valueRs]: 0, [RowsField.valueD]: 0
        }])

    const columnsManufacturingDetail = [
        {
            label: 'Party', name: RowsField.partyId, type: 'select', required: true,
            data: masterData && masterData.acMaster ? masterData.acMaster : [], keyfield: "Party_Id", valuefield: "Party_Name"
        },
        {
            label: 'Shape', name: RowsField.shapeCode, type: 'select', required: true,
            data: diamParamData && diamParamData.shapeMaster ? diamParamData.shapeMaster : [], keyfield: "S_Code", valuefield: "S_Name"
        },
        {
            label: 'Charni', name: RowsField.charni, type: 'select',
            data: masterData && masterData.charniMaster ? masterData.charniMaster : [], keyfield: "CType", valuefield: "Charni"
        },
        { label: 'Rgh.Cts.', name: RowsField.roughCts, type: 'number' },
        { label: 'Dem.Cts', name: RowsField.demandCts, type: 'number' },
        { label: 'Pol.Cts', name: RowsField.polishCts, type: 'number' },
        { label: 'Pol.Pcs', name: RowsField.polishPcs, type: 'number' },
        {
            label: 'Rate On', name: RowsField.rateOn, type: 'select', required: true,
            data: ENUM_RateOn, keyfield: "key", valuefield: "value"
        },
        { label: 'Labour Rate Rs.', name: RowsField.rateRs, type: 'number', required: true, },
        { label: 'Labour Amt. Rs.', name: RowsField.valueRs, type: 'number' },
        { label: 'Labour Amt. $', name: RowsField.valueD, type: 'number' },
    ]

    // Final Polish Assort
    const [deleteRowsFinalPolisAssort, setDeleteRowsFinalPolishAssort] = useState([])
    const [rowsFinalPolisAssort, setRowsFinalPolishAssort] = useState([
        {
            id: 1, [RowsField.detailId]: 0, [RowsField.shapeCode]: "", [RowsField.colorCode]: "", [RowsField.purityCode]: "",
            [RowsField.sizeCode]: "", [RowsField.weight]: 0, [RowsField.rateD]: 0, [RowsField.rateRs]: 0, [RowsField.valueD]: 0, [RowsField.valueRs]: 0

        }])

    const columnsFinalPolishAssort = [
        {
            label: 'Shape', name: RowsField.shapeCode, type: 'select', required: true,
            data: diamParamData && diamParamData.shapeMaster ? diamParamData.shapeMaster : [], keyfield: "S_Code", valuefield: "S_Name"
        },
        {
            label: 'Color', name: RowsField.colorCode, type: 'select', required: true,
            data: diamParamData && diamParamData.colorMaster ? diamParamData.colorMaster : [], keyfield: "Sh_Code", valuefield: "Sh_Name"
        },
        {
            label: 'Purity', name: RowsField.purityCode, type: 'select', required: true,
            data: diamParamData && diamParamData.purityMaster ? diamParamData.purityMaster : [], keyfield: "Q_Code", valuefield: "Q_Name"
        },
        {
            label: 'Size', name: RowsField.sizeCode, type: 'select', required: true,
            data: diamParamData && diamParamData.sizeMaster ? diamParamData.sizeMaster : [], keyfield: "Sz_Code", valuefield: "Sz_Name"
        },
        { label: 'Weight', name: RowsField.weight, type: 'number', required: true },
        { label: 'Rate $', name: RowsField.rateD, type: 'number', required: true },
        { label: 'Rate Rs.', name: RowsField.rateRs, type: 'number' },
        { label: 'Value $', name: RowsField.valueD, type: 'number' },
        { label: 'Value Rs.', name: RowsField.valueRs, type: 'number' },
    ]


    const inputBoxes = {
        Row1: [
            {
                id: formField.roughNo,
                name: formField.roughNo,
                placeholder: "Rough No.",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.article,
                name: formField.article,
                placeholder: "Article",
                type: ENUM_INPUT_TYPE.text,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.inwardDate,
                name: formField.inwardDate,
                placeholder: "Inward Date.",
                type: ENUM_INPUT_TYPE.date,
                size: "sm",
                label: "",
                isrequired: true,
            },],
        Row2: [
            {
                id: formField.weight,
                name: formField.weight,
                placeholder: "Weight.",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },

            {
                id: formField.rateD,
                name: formField.rateD,
                placeholder: "Rate $",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.convRate,
                name: formField.convRate,
                placeholder: "$-R",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.rateRs,
                name: formField.rateRs,
                placeholder: "Rate",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },
        ],

        Row3: [
            {
                id: formField.partyId,
                name: formField.partyId,
                placeholder: "Party ",
                type: ENUM_INPUT_TYPE.autocomplete,
                size: "sm",
                label: "",
                data: masterData && masterData?.acMaster ? masterData?.acMaster : [],
                itemkey: "Party_Id",
                itemvalue: "Party_Name",
                isrequired: true,
            },
            {
                id: formField.valueRs,
                name: formField.valueRs,
                placeholder: "Value",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },
            {
                id: formField.valueD,
                name: formField.valueD,
                placeholder: "Value $",
                type: ENUM_INPUT_TYPE.number,
                size: "sm",
                label: "",
                isrequired: true,
            },

        ],

    }

    const setCurrencyColumnVisiblity = (column) => {
        const RsCol = [RowsField.rateRs, RowsField.valueRs]
        const DCol = [RowsField.rateD, RowsField.valueD, RowsField.convRate]
        if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.RS && RsCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.Dollar && DCol.includes(column))
            return true
        else if (CurrencySetting == ENUM_CURRENCY_SETTING_VAL.DUAL)
            return true
        else
            return true
    }

    //console.log(detail, "dtaa detail")

    useEffect(() => {
        if (!isNewEntry && detailParams && Object.keys(detailParams).length > 0) {
            if (detail && detail?.allotData && detail?.allotData?.length > 0) {
                setFormData({
                    [formField.roughNo]: detail?.allotData[0]?.Rgh_Code ?? '',
                    [formField.article]: detail?.allotData[0]?.Rgh_Name ?? '',
                    [formField.inwardDate]: detail?.allotData[0]?.R_InwardDate ?? null,
                    [formField.weight]: detail?.allotData[0]?.R_Carat.toFixed(2) ?? 0,
                    [formField.rateD]: detail?.allotData[0]?.DRate.toFixed(2) ?? 0,
                    [formField.convRate]: detail?.allotData[0]?.CRate.toFixed(2) ?? 0,
                    [formField.rateRs]: detail?.allotData[0]?.Rate.toFixed(2) ?? 0,
                    [formField.partyId]: detail?.allotData[0]?.Pac_Id ?? '',
                    [formField.valueD]: detail?.allotData[0]?.AmountD.toFixed(2) ?? 0,
                    [formField.valueRs]: detail?.allotData[0]?.Amount.toFixed(2) ?? 0,
                    [formField.remark]: detail?.allotData[0]?.Lot_Remark ?? '',

                })
                if (detail && detail?.clvData && detail?.clvData?.length > 0) {
                    const data = detail?.clvData.filter(find => find.Entry_Of == 'R').map((item, index) => {
                        return {
                            id: index + 1,
                            [RowsField.detailId]: item?.DetNo ?? 0,
                            [RowsField.assortCode]: item?.Clv_Code ?? '',
                            [RowsField.weight]: item?.R_Carat.toFixed(2) ?? 0,
                            [RowsField.rateD]: item?.D_Rate.toFixed(2) ?? 0,
                            [RowsField.valueD]: item?.AmountD.toFixed(2) ?? 0,
                            [RowsField.rateRs]: item?.Rate.toFixed(2) ?? 0,
                            [RowsField.valueRs]: item?.Amount.toFixed(2) ?? 0,
                        }
                    })
                    setRowsOriginalAssort(data)
                }
                let RejData = []
                let FinalAssortData = []
                let ProcessData = []
                let MfgData = []
                const LotData = detail?.allotData.map((ele, indx) => {

                    if (detail && detail?.clvData && detail?.clvData?.length > 0) {
                        const data = detail?.clvData.filter(find => find.Entry_Of == 'L' && find.L_Code == ele.L_Code).map((item, index) => {
                            return {
                                id: index + 1,
                                [RowsField.detailId]: item?.DetNo ?? 0,
                                [RowsField.rejectionType]: item?.Clv_Code ?? '',
                                [RowsField.weight]: item?.R_Carat.toFixed(2) ?? 0,
                                [RowsField.rateD]: item?.D_Rate.toFixed(2) ?? 0,
                                [RowsField.valueD]: item?.AmountD.toFixed(2) ?? 0,
                                [RowsField.rateRs]: item?.Rate.toFixed(2) ?? 0,
                                [RowsField.valueRs]: item?.Amount.toFixed(2) ?? 0
                            }
                        })
                        RejData = data;
                    }
                    if (detail && detail?.dimTranData && detail?.dimTranData?.length > 0) {
                        const data = detail?.dimTranData.filter(find => find.I_Type == 'P' && find.L_Code == ele.L_Code).map((item, index) => {
                            return {
                                id: index + 1,
                                [RowsField.detailId]: item?.SrNo ?? 0,
                                [RowsField.processType]: String(item?.Process ?? 0),
                                [RowsField.weight]: item?.I_Carat.toFixed(2) ?? 0,
                                [RowsField.lossWeight]: (parseFloat(item?.I_Carat ?? 0) - parseFloat(item?.R_Carat)).toFixed(2) ?? 0,
                                [RowsField.lossPer]: ((parseFloat(item?.R_Carat ?? 0) * 100) / parseFloat(item?.I_Carat)).toFixed(2) ?? 0,
                                [RowsField.rateRs]: item?.Rate.toFixed(2) ?? 0,
                                [RowsField.valueRs]: item?.Amount.toFixed(2) ?? 0,
                                [RowsField.valueD]: item?.AmountD.toFixed(2) ?? 0
                            }
                        })
                        ProcessData = data

                        const mData = detail?.dimTranData.filter(find => find.I_Type == 'M' && find.L_Code == ele.L_Code).map((item, index) => {
                            return {
                                id: index + 1,
                                [RowsField.detailId]: item?.SrNo ?? 0,
                                [RowsField.partyId]: item?.Pac_Id ?? '',
                                [RowsField.shapeCode]: item?.S_Code ?? '',
                                [RowsField.charni]: item?.Charni_H ?? '',
                                [RowsField.polishPcs]: item?.R_Pcs ?? 0,
                                [RowsField.rateOn]: item?.Rate_On ?? '',
                                [RowsField.roughCts]: item?.I_Carat.toFixed(2) ?? 0,
                                [RowsField.demandCts]: item?.Dem_Carat.toFixed(2) ?? 0,
                                [RowsField.polishCts]: item?.R_Carat.toFixed(2) ?? 0,
                                [RowsField.rateRs]: item?.Rate.toFixed(2) ?? 0,
                                [RowsField.valueRs]: item?.Amount.toFixed(2) ?? 0,
                                [RowsField.valueD]: item?.AmountD.toFixed(2) ?? 0
                            }
                        })
                        MfgData = mData

                    }
                    if (detail && detail?.polGradData && detail?.polGradData?.length > 0) {
                        const data = detail?.polGradData.filter(find => find.L_Code == ele.L_Code).map((item, indx) => {
                            return {
                                id: indx + 1,
                                [RowsField.detailId]: item?.DetNo ?? 0,
                                [RowsField.shapeCode]: item?.S_Code ?? '',
                                [RowsField.colorCode]: item?.Sh_Code ?? '',
                                [RowsField.purityCode]: item?.Q_Code ?? '',
                                [RowsField.sizeCode]: item?.Sz_Code ?? '',
                                [RowsField.weight]: item?.R_Carat.toFixed(2) ?? 0,
                                [RowsField.rateD]: item?.PolDRate.toFixed(2) ?? 0,
                                [RowsField.rateRs]: item?.Rate.toFixed(2) ?? 0,
                                [RowsField.valueD]: item?.AmountD.toFixed(2) ?? 0,
                                [RowsField.valueRs]: item?.Amount.toFixed(2) ?? 0,

                            }

                        })
                        FinalAssortData = data
                    }
                    return {
                        id: indx + 1,
                        [RowsField.detailId]: ele?.L_Code != '' && ele?.L_Code != null ? 1 : 0,
                        [RowsField.lotNo]: ele?.L_Code ?? '',
                        [RowsField.assortCode]: ele?.Lot_FinalAssort ?? '',
                        [RowsField.clvDate]: ele?.Clvi_Date ?? null,
                        [RowsField.cleaver]: ele?.Lot_ClvCode ?? '',
                        [RowsField.weight]: ele?.Lot_ICarat.toFixed(2) ?? 0,
                        [RowsField.rateD]: ele?.Lot_SRate.toFixed(2) ?? 0,
                        [RowsField.convRate]: ele?.Lot_CRate.toFixed(2) ?? 0,
                        [RowsField.rateRs]: ele?.Lot_Rate.toFixed(2) ?? 0,
                        [RowsField.finalDate]: ele?.Lot_PolrDate ?? null,
                        rejectionDetail: RejData,
                        finalpolishDetail: FinalAssortData,
                        processDetail: ProcessData,
                        mfgDetail: MfgData
                    }

                })
                setRowsLotAssort(LotData)

            }



        }
    }, [detail])

    const handleChange = (e) => {
        const { value, id, } = e.target

        if (id == formField.weight || id == formField.rateD || id == formField.rateRs) {
            let tempVal = 0;
            const t_weight = id == formField.weight ? value : formData[formField.weight]
            const t_rated = id == formField.rateD ? value : formData[formField.rateD]
            const t_rate = id == formField.rateRs ? value : formData[formField.rateRs]

            tempVal = parseFloat(t_weight) * parseFloat(t_rated)
            const valD = funCheckNumber(tempVal).toFixed(2)
            tempVal = parseFloat(t_weight) * parseFloat(t_rate)
            const val = funCheckNumber(tempVal).toFixed(2)

            setFormData({ ...formData, [id]: value, [formField.valueD]: valD, [formField.valueRs]: val })
        }
        else
            setFormData({ ...formData, [id]: value })
    }


    const handleBlur = (e) => {
        const { name, value } = e.target
        const isValid = funValidateNoInput(value);

        if (![formField.roughNo, formField.article].includes(name) && isValid) {
            const formatted = funCheckNumber(parseFloat(value || 0)).toFixed(2);
            setFormData({ ...formData, [name]: formatted })
        }
        if (name == formField.roughNo && isNewEntry) {
            funChkRoughNo({
                data: {
                    roughno: value
                }
            })
        }
        if (name == formField.convRate) {

        }
    }


    const [errors, setErrors] = useState({})

    const validateForm = () => {
        const newErrors = {}
        if (formData[formField.roughNo] == "" || formData[formField.roughNo] != null) {
            newErrors[formField.roughNo] = "Rough No required"
        }
        if (formData[formField.inwardDate] == "" || formData[formField.inwardDate] != null) {
            newErrors[formField.inwardDate] = "Inward Date required"
        }
        if (formData[formField.partyId] == "" || formData[formField.partyId] != null) {
            newErrors[formField.partyId] = "Party required"
        }
        if (formData[formField.weight] == "" || formData[formField.weight] <= 0) {
            newErrors[formField.weight] = "Weight required"
        }
        if (formData[formField.rateRs] == "" || formData[formField.rateRs] <= 0) {
            newErrors[formField.rateRs] = "Rate required"
        }


        setErrors(newErrors)

        // Return true if there are no errors
        return Object.keys(newErrors).length === 0
    }


    const [isFocus, setIsFocus] = useState(false)

    const handleAutoCompleteChange = (value, id, name) => {
        setFormData({ ...formData, [name]: value })
    }

    const funGetMasterLink = () => {
        return linksUrl.roughAllotment.allotmentEntryMaster
    }

    const handleClickPrev = () => {
        navigate(funGetMasterLink())
    }

    const handleSubmit = (e) => {
        e.preventDefault()

        // const validate_form = validateForm()
        setSubmitBtnId(e.nativeEvent.submitter.id)
        const deleteItems = {
            org_allotment: deleteRowsOriginalAssort,
            lot_allotment: deleteRowsLotlAssort,
            rej_detail: deleteRowsRejectionDetail,
            pro_detail: deleteRowsProcessDetail,
            mfg_detail: deleteRowsManufacturingDetail,
            final_detail: deleteRowsFinalPolisAssort
        }

        const grid_msg = true;
        if (grid_msg) {
            funAddUpdate({
                data: {
                    comp_code: compCode.join(","),
                    rough_code: formData[formField.roughNo],
                    rough_name: formData[formField.article],
                    inward_date: formData[formField.inwardDate],
                    conv_rate: formData[formField.convRate],
                    weight: formData[formField.weight],
                    rate: formData[formField.rateRs],
                    rated: formData[formField.rateD],
                    partyId: formData[formField.partyId],
                    org_allotment: rowsOriginalAssort,
                    lot_allotment: rowsLotlAssort,
                    delete_items: deleteItems,
                    remark: formData[formField.remark],
                    login_userid: user.username,
                    rec_status: !isNewEntry ? 1 : 2
                }
            })
        }
        else {
            toast.error(grid_msg, {
                "position": "top-center"

            })
        }

    }

    useEffect(() => {

        if (selLotAllotData && Object.keys(selLotAllotData).length > 0) {
            setSelTabKey("lotAllotmentDetail")
            const rowIndex = rowsLotlAssort.findIndex(ele => ele.lotNo == selLotAllotData.lotNo);
            setRowsRejectionDetail(rowsLotlAssort[rowIndex]["rejectionDetail"] || [])
            setRowsProcessDetail(rowsLotlAssort[rowIndex]["processDetail"] || [])
            setRowsManufacturingDetail(rowsLotlAssort[rowIndex]["mfgDetail"] || [])
            setRowsFinalPolishAssort(rowsLotlAssort[rowIndex]["finalpolishDetail"] || [])
        }

    }, [selLotAllotData])

    useEffect(() => {

        if (selLotAllotData && Object.keys(selLotAllotData).length > 0) {
            //const d= rowsLotlAssort.filter(ele=>ele.lotNo==selLotAllotData.lotNo)
            const rowIndex = rowsLotlAssort.findIndex(ele => ele.lotNo === selLotAllotData.lotNo);
            const updated = [...rowsLotlAssort];
            updated[rowIndex]["rejectionDetail"] = rowsRejectionDetail;
            updated[rowIndex]["processDetail"] = rowsProcessDetail;
            updated[rowIndex]["mfgDetail"] = rowsManufacturingDetail;
            updated[rowIndex]["finalpolishDetail"] = rowsFinalPolisAssort;
        }

    }, [rowsRejectionDetail, selLotAllotData, rowsProcessDetail, rowsManufacturingDetail, rowsFinalPolisAssort])
    useEffect(() => {
        scrollInput()
    }, []);
    const DispLotHead = {
        [RowsField.lotNo]: "Lot No",
        [RowsField.assortCode]: "Assort No",
        [RowsField.clvDate]: "Clv Date",
        [RowsField.cleaver]: "Cleaver",
        [RowsField.weight]: "Weight",
        [RowsField.rateD]: "Rate $",
        [RowsField.convRate]: "$-Rs",
        [RowsField.rateRs]: "Rate Rs",
        [RowsField.finalDate]: "Final Date"
    }
    if (isError) {

        return <ErrorCard />
    }
    if (isPending) {
        return <LoadingCard />
    }
    //onsole.log(selLotAllotData, "aklot")
    return (
        <div>
            <MainContainer
                pageName={`${isNewEntry ? "New" : "Update"} Rough Allotment Entry `}
                breadcrumbs={["Stock", "Rough Allotment Entry",]}
                prevPage={{
                    show: true,
                    onClick: handleClickPrev,
                }}
            >
                <Card shadow="sm" className={stickyParentClass}>
                    <form onSubmit={handleSubmit} autoComplete='off'>
                        <CardBody>
                            <div>
                                {
                                    Object.keys(inputBoxes).map((key, ind) => (
                                        <div key={key + ind}>
                                            <div className={` ${isMobile ? 'flex-wrap' : ''}   flex gap-4 align-top items-baseline mb-2 `}>
                                                {
                                                    inputBoxes[key].map((item, indx) =>
                                                        item.type == ENUM_INPUT_TYPE.select ? (
                                                            <></>
                                                        ) : item.type == ENUM_INPUT_TYPE.autocomplete ? (
                                                            <Autocomplete
                                                                size="sm"
                                                                name={item.name}
                                                                //isInvalid={errors[item.name]}
                                                                //  errorMessage={errors[item.name]}
                                                                label={item?.placeholder}
                                                                eventResizeFeature={true}
                                                                selectionMode="single"
                                                                showScrollIndicators={true}
                                                                labelPlacement={"outside"}
                                                                placeholder={item.placeholder}
                                                                isRequired={item.isrequired}
                                                                menuTrigger={"input"}
                                                                isLoading={isPendingData}
                                                                className="max-w-23"
                                                                classNames={{
                                                                    label: "text-xs text-black font-bold",
                                                                }}
                                                                color="warning"
                                                                isClearable={false}
                                                                isVirtualized
                                                                isReadOnly={item.name == formField.stockType && !isNewEntry ?
                                                                    true : false}
                                                                defaultItems={
                                                                    item.data ? item.data : []
                                                                }
                                                                onSelectionChange={(e) =>
                                                                    handleAutoCompleteChange(e, '', item.name)
                                                                }
                                                                //                                                            color={item.id == formField.debitAcId ? "success" : item.id == formField.creditAcId ? "primary" : ""}
                                                                //onChange={handleFormSelectionChange}
                                                                selectedKey={formData[item.name]}
                                                            >
                                                                {(list) => (
                                                                    <AutocompleteItem

                                                                        key={list[item.itemkey]}
                                                                    >
                                                                        {list[item.itemvalue]}
                                                                    </AutocompleteItem>
                                                                )}
                                                            </Autocomplete>
                                                        ) : item.type == ENUM_INPUT_TYPE.date ? (
                                                            <div className=" w-full flex items-center">
                                                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                                    <DatePicker
                                                                        label={item.placeholder}
                                                                        views={["day", "month", "year"]}
                                                                        format="DD/MM/YYYY"
                                                                        value={
                                                                            formData[item.name]
                                                                                ? dayjs(formData[item.name])
                                                                                : formData[item.name]
                                                                        }
                                                                        onChange={(newValue) => {
                                                                            setFormData((prev) => {
                                                                                return {
                                                                                    ...prev,
                                                                                    [item.name]: newValue != '' && newValue != 'Invalid Date' ?
                                                                                        dayjs(newValue).format("YYYY-MM-DD") : null,
                                                                                };
                                                                            });
                                                                        }}
                                                                        //isRequired={item.required}
                                                                        className="w-full "
                                                                        slotProps={{
                                                                            textField: { size: "small", required: true },
                                                                        }}
                                                                    />
                                                                </LocalizationProvider>
                                                            </div>
                                                        ) : (
                                                            setCurrencyColumnVisiblity(item.name) ?
                                                                <Input
                                                                    type={item.type}
                                                                    name={item.name}
                                                                    id={item.name}
                                                                    //isInvalid={errors[item.name]}
                                                                    //errorMessage={errors[item.name]}
                                                                    placeholder={item.placeholder}
                                                                    label={item.placeholder}
                                                                    labelPlacement="outside"
                                                                    isRequired={item.isrequired}
                                                                    value={formData[item.name]}
                                                                    variant={item.name == formField.roughNo ? "flat" : "bordered"}
                                                                    onChange={(e) => handleChange(e)}
                                                                    color={item.name == formField.roughNo ? "danger" : "default"}
                                                                    onBlur={(e) => handleBlur(e)}
                                                                    isReadOnly={item.name == [formField.roughNo] && !isNewEntry ? true : false}
                                                                    size={"sm"}
                                                                    classNames={{
                                                                        label: "text-xs text-black font-bold",
                                                                    }}
                                                                ></Input>
                                                                : ""
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    ))
                                }

                                <div className={` flex gap-4 item-center mb-2 `}>
                                    <Textarea
                                        type="text"
                                        id={formField.remark}
                                        name={formField.remark}
                                        placeholder={"Remarks"}
                                        label={"Remark"}
                                        labelPlacement="outside"
                                        variant="bordered"
                                        classNames={{
                                            label: "text-xs text-black font-bold",
                                        }}
                                        value={formData[formField.remark]}
                                        size={"sm"}
                                        onChange={handleChange}
                                    >

                                    </Textarea>

                                </div>
                            </div>
                            <div className=" mt-2 border-t-2 shadow border-blue-200 ml-1 pt-3">
                                <Tabs color="primary" selectedKey={selTabKey} onSelectionChange={setSelTabKey} classNames={{ tabList: "bg-orange-200 ", }} radius="none"
                                    variant="solid">
                                    <Tab key="orgAllotment" title="Original Allotment">
                                        <DynamicTable currency={CurrencySetting} tabId="Merge" RowsField={RowsField} columns={columnsOrignalAssort} rows={rowsOriginalAssort} onChange={setRowsOriginalAssort}
                                            onLotAllotChange={setSelLotAllotData}
                                            onDelete={setDeleteRowsOriginalAssort} deleteRows={deleteRowsOriginalAssort}
                                        />
                                    </Tab>
                                    <Tab key="lotAllotment" title="Lot Allotment">
                                        <DynamicTable currency={CurrencySetting} tabId="Merge" RowsField={RowsField} columns={columnsLotAssort} rows={rowsLotlAssort} onChange={setRowsLotAssort}
                                            onDelete={setDeleteRowsLotAssort} deleteRows={deleteRowsLotlAssort}
                                            onLotAllotChange={setSelLotAllotData} />
                                    </Tab>
                                    <Tab key="lotAllotmentDetail" isDisabled={true} title="Lot Details">
                                        {
                                            selLotAllotData && Object.keys(selLotAllotData).length > 0 ?
                                                <div className="flex w-full mb-3  font-semibold  flex-wrap gap-0">
                                                    <div className=" flex-col border-1 border-green-200 text-center items-top justify-center">
                                                        <div className="  bg-green-100   py-1 px-5 text-xs uppercase border-b">Rough  Info.</div>
                                                        <div className="p-1 text-xs text-orange-500">
                                                            <h1>{formData.roughNo} - {formData.article}</h1>
                                                            <h1>Wt : {formData.weight}</h1>
                                                        </div>
                                                    </div>
                                                    {Object.entries(selLotAllotData).filter(([key]) => [RowsField.lotNo, RowsField.assortCode, RowsField.clvDate,
                                                    RowsField.cleaver, RowsField.weight, RowsField.rateD, RowsField.convRate, RowsField.rateRs, RowsField.finalDate].includes(key)).map(([key, value]) => (
                                                        <div
                                                            key={key}
                                                            className=" flex-col border-1 border-green-200 text-center items-top justify-center"

                                                        >
                                                            <div className="  bg-green-100   py-1 px-5 text-xs uppercase border-b">{DispLotHead[key]}</div>
                                                            <div className="p-1 text-sm text-blue-800">{value !== null && value !== '' ?
                                                                (key == RowsField.clvDate || key == RowsField.finalDate) ? dayjs(value).format("DD-MM-YYYY") : value : <i style={{ color: '#888' }}>empty</i>}</div>
                                                        </div>
                                                    ))}
                                                </div> : ""
                                        }
                                        <Tabs classNames={{ tabList: "bg-green-200" }} radius="none" className="m-0 p-0" variant="solid" color="success" >
                                            <Tab key="rejectDetail" title={"Rejection Details"}>
                                                <DynamicTable currency={CurrencySetting} RowsField={RowsField} tabId={"rejectDetail"} cRate={formData[formField.convRate]} columns={columnsRejectionDetail} rows={rowsRejectionDetail}
                                                    selLotAllotRow={selLotAllotData} onDelete={setDeleteRowsRejectionDetail} deleteRows={deleteRowsRejectionDetail}
                                                    onChange={setRowsRejectionDetail} />
                                            </Tab>
                                            <Tab key="processDetail" title={"Process Details"}>
                                                <DynamicTable currency={CurrencySetting} RowsField={RowsField} tabId={"processDetail"} cRate={formData[formField.convRate]} columns={columnsProcessDetail} rows={rowsProcessDetail}
                                                    selLotAllotRow={selLotAllotData} onDelete={setDeleteRowsProcessDetail} deleteRows={deleteRowsProcessDetail}
                                                    onChange={setRowsProcessDetail} />
                                            </Tab>
                                            <Tab key="mfgDetail" title={"Manufacturing Details"}>
                                                <DynamicTable currency={CurrencySetting} RowsField={RowsField} tabId={"mfgDetail"} cRate={formData[formField.convRate]} columns={columnsManufacturingDetail} rows={rowsManufacturingDetail} selLotAllotRow={selLotAllotData}
                                                    onChange={setRowsManufacturingDetail}
                                                    onDelete={setDeleteRowsManufacturingDetail} deleteRows={deleteRowsManufacturingDetail}
                                                />
                                            </Tab>
                                            <Tab key="finalProcess" title={"Final Process Assort"}>
                                                <DynamicTable currency={CurrencySetting} RowsField={RowsField} tabId={"finalProcess"} cRate={formData[formField.convRate]} columns={columnsFinalPolishAssort} rows={rowsFinalPolisAssort} selLotAllotRow={selLotAllotData}
                                                    onChange={setRowsFinalPolishAssort}
                                                    onDelete={setDeleteRowsFinalPolishAssort} deleteRows={deleteRowsFinalPolisAssort}
                                                />
                                            </Tab>
                                        </Tabs>

                                    </Tab>
                                </Tabs>
                            </div>

                        </CardBody>
                        <div className={stickyBottomClass}>
                            <div className="justify-center flex items-center gap-4">
                                {/* <div className="justify-center flex gap-5 mt-5"> */}
                                <Button
                                    color="primary"
                                    type="submit"
                                    id="btnSave"
                                    size="sm"
                                    variant="shadow"
                                    tabIndex={-1}
                                    isLoading={isPending}
                                    startContent={<FontAwesomeIcon icon={faSave} />}
                                >
                                    Submit
                                </Button>
                                <Button
                                    id="btnSaveNew"
                                    color="success"
                                    type="submit"
                                    size="sm"
                                    variant="shadow"
                                    className="text-white"
                                    startContent={<FontAwesomeIcon className=" text-md text-white" icon={faFile} />}
                                >
                                    Save & New
                                </Button>
                                <Button
                                    color="danger"
                                    variant="shadow"
                                    size="sm"
                                    tabIndex={-1}
                                    onPress={handleClickPrev}
                                    startContent={<FontAwesomeIcon icon={faCancel} />}
                                >
                                    Cancel
                                </Button>
                            </div>
                        </div>

                    </form >
                </Card >
            </MainContainer>
        </div>
    )
}
export default CreateRoughAllotmentEntry